<template>
  <b-sidebar
    id="edit-contact-sidebar"
    :visible="isEditContactSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="val => $emit('update:is-edit-contact-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Edit Contact
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <!-- BODY -->
      <validation-observer
        ref="refFormObserver"
        #default="{invalid}"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="submitEdit"
        >
          <!-- Name -->
          <validation-provider
            #default="validationContext"
            name="Name"
            rules="required"
          >
            <b-form-group label-for="contactName">
              <template #label>
                Name <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="contactName"
                v-model="contactName"
                autofocus
                :state="getValidationState(validationContext)"
                trim
                placeholder="Name"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Category -->
          <validation-provider
            #default="validationContext"
            name="Category"
            rules="required"
          >
            <b-form-group label-for="contactCategory">
              <template #label>
                Category <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="contactCategory"
                v-model="contactCategory"
                v-uppercase
                :state="getValidationState(validationContext)"
                trim
                placeholder="Category"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Type -->
          <validation-provider
            #default="validationContext"
            name="Type"
            rules="required"
          >
            <b-form-group label-for="contactType">
              <template #label>
                Type <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="contactType"
                v-model="contactType"
                v-uppercase
                :state="getValidationState(validationContext)"
                trim
                placeholder="Type"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Address -->
          <validation-provider
            #default="validationContext"
            name="Address"
            rules="required"
          >
            <b-form-group label-for="contactAddress">
              <template #label>
                Address <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="contactAddress"
                v-model="contactAddress"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Address"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- City -->
          <validation-provider
            #default="validationContext"
            name="City"
            rules="required"
          >
            <b-form-group label-for="contactCitys">
              <template #label>
                City <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="contactCitys"
                v-model="contactCity"
                :state="getValidationState(validationContext)"
                trim
                placeholder="City"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Postal Code -->
          <validation-provider
            #default="validationContext"
            name="Postal Code"
            rules="required"
          >
            <b-form-group label-for="contactPostalCode">
              <template #label>
                Postal Code <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="contactPostalCode"
                v-model="contactPostalCode"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Postal Code"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Phone 1 -->
          <validation-provider
            #default="validationContext"
            name="Phone1"
            rules="required"
          >
            <b-form-group label-for="Phone1">
              <template #label>
                Phone 1 <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="Phone1"
                v-model="contactPhone1"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Phone 1"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Phone 2 -->
          <validation-provider
            #default="validationContext"
            name="Phone2"
          >
            <b-form-group
              label="Phone 2"
              label-for="Phone2"
            >
              <b-form-input
                id="Phone2"
                v-model="contactPhone2"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Phone 2"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Fax -->
          <validation-provider
            #default="validationContext"
            name="Fax"
          >
            <b-form-group
              label="Fax"
              label-for="Fax"
            >
              <b-form-input
                id="Fax"
                v-model="contactFax"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Fax"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Email -->
          <validation-provider
            #default="validationContext"
            name="Email"
            rules="required"
          >
            <b-form-group label-for="Email">
              <template #label>
                Email <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="Email"
                v-model="contactEmail"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Email"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- PIC Name -->
          <validation-provider
            #default="validationContext"
            name="PicName"
            rules="required"
          >
            <b-form-group label-for="PicName">
              <template #label>
                PIC Name <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="PicName"
                v-model="contactPicName"
                :state="getValidationState(validationContext)"
                trim
                placeholder="PIC Name"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- PIC Phone -->
          <validation-provider
            #default="validationContext"
            name="PicPhone"
            rules="required"
          >
            <b-form-group label-for="PicPhone">
              <template #label>
                PIC Phone <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="PicPhone"
                v-model="contactPicPhone"
                :state="getValidationState(validationContext)"
                trim
                placeholder="PIC Phone"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Bank 1 -->
          <validation-provider
            #default="validationContext"
            name="Bank1"
            rules="required"
          >
            <b-form-group label-for="Bank1">
              <template #label>
                Bank 1 <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="Bank1"
                v-model="contactBank1"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Bank 1"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Bank 2 -->
          <validation-provider
            #default="validationContext"
            name="Bank2"
          >
            <b-form-group
              label="Bank 2"
              label-for="Bank2"
            >
              <b-form-input
                id="Bank2"
                v-model="contactBank2"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Bank 2"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Bank 3 -->
          <validation-provider
            #default="validationContext"
            name="Bank3"
          >
            <b-form-group
              label="Bank 3"
              label-for="Bank3"
            >
              <b-form-input
                id="Bank3"
                v-model="contactBank3"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Bank 3"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
              block
              :disabled="invalid"
            >
              Save
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hideSidebar()"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, alphaNum } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import axios from 'axios'
import moment from 'moment-timezone'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import apiEndpoints from '@/constants/apiEndpoints'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isEditContactSidebarActive',
    event: 'update:is-edit-contact-sidebar-active',
  },
  props: {
    isEditContactSidebarActive: {
      type: Boolean,
      required: true,
    },
    contactName: {
      type: String,
      required: true,
    },
    contactCategory: {
      type: String,
      required: true,
    },
    contactType: {
      type: String,
      required: true,
    },
    contactId: {
      type: String,
      required: true,
    },
    contactAddress: {
      type: String,
      required: true,
    },
    contactCity: {
      type: String,
      required: true,
    },
    contactPostalCode: {
      type: String,
      required: true,
    },
    contactPhone1: {
      type: String,
      required: true,
    },
    contactPhone2: {
      type: String,
      required: false,
    },
    contactFax: {
      type: String,
      required: false,
    },
    contactEmail: {
      type: String,
      required: false,
    },
    contactPicName: {
      type: String,
      required: false,
    },
    contactPicPhone: {
      type: String,
      required: false,
    },
    contactBank1: {
      type: String,
      required: false,
    },
    contactBank2: {
      type: String,
      required: false,
    },
    contactBank3: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      required,
      alphaNum,
    }
  },
  setup() {
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(() => {})

    return {
      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
  mounted() {
    const data = this.$cookies.get('contactEdit')
    // FIXED: Now we are loading all fields into the form when editing, not just the name.
    if (data !== null) {
      this.contactId = data.contact_id
      this.contactName = data.contact_name
      this.contactCategory = data.contact_category
      this.contactType = data.contact_type
      this.contactAddress = data.contact_address
      this.contactCity = data.contact_city
      this.contactPostalCode = data.contact_postal_code
      this.contactPhone1 = data.contact_phone_1
      this.contactPhone2 = data.contact_phone_2
      this.contactFax = data.contact_fax
      this.contactEmail = data.contact_email
      this.contactPicName = data.contact_pic_name
      this.contactPicPhone = data.contact_pic_phone
      this.contactBank1 = data.contact_bank_1
      this.contactBank2 = data.contact_bank_2
      this.contactBank3 = data.contact_bank_3
    }
  },
  methods: {
    hideSidebar() {
      this.isEditContactSidebarActive = false
    },
    submitEdit() {
      const userToken = this.$cookies.get('userToken')
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userToken}`,
      }

      const payload = {
        contact_id: this.contactId,
        contact_name: this.contactName,
        contact_category: this.contactCategory,
        contact_type: this.contactType,
        contact_address: this.contactAddress,
        contact_city: this.contactCity,
        contact_postal_code: this.contactPostalCode,
        contact_phone_1: this.contactPhone1,
        contact_phone_2: this.contactPhone2,
        contact_fax: this.contactFax,
        contact_email: this.contactEmail,
        contact_pic_name: this.contactPicName,
        contact_pic_phone: this.contactPicPhone,
        contact_bank_1: this.contactBank1,
        contact_bank_2: this.contactBank2,
        contact_bank_3: this.contactBank3,
        time: moment().format(),
      }

      const url = `${process.env.VUE_APP_API_URL}${apiEndpoints.API_EDIT_CONTACT}`

      axios
        .post(url, payload, { headers })
        .then(response => {
          if (response.data.success === true) {
            this.$root.$emit('refreshTable', 'refreshTable')
            this.isEditContactSidebarActive = false
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Congratulation',
                icon: 'CoffeeIcon',
                variant: 'success',
                text: 'Your data has been saved!',
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Notification',
                icon: 'BellIcon',
                variant: 'danger',
                text: 'Something went wrong',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Notification',
              icon: 'BellIcon',
              variant: 'danger',
              text: 'Something went wrong',
            },
          })
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#edit-contact-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
